import {ajax} from './ajax'

//1、获取学生学习进度
export const reqlearningProgress = (paramets) => ajax(`/effect/jxEffect/progressList`,paramets)

//2、获取活动参与率
export const reqActivityParticipation = (paramets) => ajax(`/homepage/teachingHomepage/participationRankList`,paramets)

//3、获取活动组织次数
export const reqActivityTime = (paramets) => ajax(`/effect/jxEffect/activityOrganizationList`,paramets)

//4、获取考勤预警
export const reqAttendanceWarning = (paramets) => ajax(`/effect/jxEffect/checkingList`,paramets)

//5、获取预习预警
export const reqPrepareWarning = (paramets) => ajax(`/effect/jxEffect/prepareList`,paramets)

//6、获取作业预警
export const reqJobWarning = (paramets) => ajax(`/effect/jxEffect/jobList`,paramets)

//7、获取活动预警
export const reqActivityWarning = (paramets) => ajax(`/effect/jxEffect/activityList`,paramets)

//8、获取学生过程性评价
export const reqEvaluateList = (paramets) => ajax(`/effect/jxEffect/evaluateList`,paramets)

//9、获取教学明细表
export const reqteachDetail = (paramets) => ajax(`/effect/jxEffect/teachingList`,paramets)

//9、获取教学明细表
export const reqheadInformation = (paramets) => ajax(`/effect/jxEffect/headInformation`,paramets)


// WEBPACK FOOTER //
// ./src/api/effect.js